import { object } from 'yup';
import {
  mapErrors,
  objectIsValid,
} from '@mgo/core/src/validations/utils';
import months from './months';
import validators from './validations';
import pageView from '../../mixins/pageView';
import { isDesktop } from '../../utils/deviceType';

export default {
  mixins: [pageView],
  data() {
    return {
      startDate: '',
      lazy: true,
      month: '',
      day: '',
      year: '',
      dobVerified: false,
    };
  },
  async mounted() {
    if (!this.$coa.coaUUID) {
      window.location.href = '/';
      return;
    }

    // enable loader for redirect
    this.$store.commit('ENABLE_LOADER');

    await this.hydrateCOA();

    /*
     * redirect back to disclaimer
     * if base data (startDate) isn't available
     */
    if (!this.startDate) {
      this.$router.push({ name: 'disclaimer' });
      this.$store.commit('DISABLE_LOADER');
      return;
    }

    this.$store.commit('DISABLE_LOADER');
    this.pageView();
  },
  computed: {
    showChoiceExperience() {
      return this.showNonControlExperience || this.showExperienceA || this.showExperienceB;
    },
    showNonControlExperience: () => JSON.parse(sessionStorage.getItem('showNonControlExperience')),
    showExperienceA: () => JSON.parse(sessionStorage.getItem('showExperienceA')),
    showExperienceB: () => JSON.parse(sessionStorage.getItem('showExperienceB')),
    progressStep() {
      return Math.floor((this.current / this.totalSteps) * 100);
    },
    current() {
      return isDesktop() ? '3' : '4';
    },
    dateOfBirth() {
      if (!(this.year && this.month && this.day)) {
        return '';
      }
      return `${this.year}-${this.month}-${this.day}`;
    },
    months() {
      return months;
    },
    days() {
      return Array.from(new Array(31), (_, i) => {
        const curr = (i + 1).toString();
        if (curr.length === 1) return `0${curr}`;
        return curr;
      });
    },
    years() {
      const today = new Date();

      return Array.from(new Array(100 - 13), (_, i) => today.getFullYear() - 13 - i);
    },
    rules() {
      return object().shape(validators);
    },
    errors() {
      const fieldsToValidate = ['dateOfBirth', 'dobVerified'];

      return mapErrors(this, fieldsToValidate);
    },
    formIsValid() {
      return objectIsValid(this.errors);
    },
  },
  methods: {
    async validate() {
      this.lazy = false;
      await this.$nextTick();
      if (!this.formIsValid) return this.scrollToFirstError();
      return this.submit();
    },
    async scrollToFirstError() {
      const errorHTML = document.querySelector('.errors');
      if (errorHTML !== null) {
        setTimeout(() => {
          errorHTML.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    },
    async hydrateCOA() {
      const { uuid, ...coa } = await this.$coa.coaGet() || {};
      if (uuid) {
        this.startDate = coa.startDate;
      }
    },
    async submit() {
      const cuid = await this.$coa.verifyAge(this.dateOfBirth);
      if (cuid) this.next(cuid);
    },
    async next(cuid) {
      await this.$nextTick();

      this.$router.push({
        name: 'action',
        query: {
          cuid,
          coa_uuid: this.$coa.coaUUID,
        },
      });
    },
  },
};
